import {icons} from '@superweb/ui'
import {useToggle} from '@yandex-delivery/hooks'
import {ListButton, Typography} from '@yandex-delivery/ui'
import {tag2url} from '@yandex-delivery/utils'
import {SafeHTML} from '@yandex-delivery/xss-defender'
import clsx from 'clsx'
import React from 'react'

import {type BlockWithoutValuesType} from '../../../../../../api'
import {Paper} from '../../../../../../components/ui'
import {Message} from '../../../Message/Message@mobile'
import {useBlocksLayout} from '../../BlocksLayoutProvider'
import {Divider, Subtitle, Title} from '../ui'
import styleClasses from './classes.module.css'
import {useAction} from './hooks'
import {useConfig} from '../../../../../../config'

type Props = {
  block: BlockWithoutValuesType
  isTopBlock?: boolean
}

export function BlockWithoutValues({block, isTopBlock}: Props) {
  const {title, subtitle, text, mayBeCollapsed, icon, action} = block

  const [opened, toggleOpened] = useToggle(false)
  const actionInfo = useAction(action)
  const {isMobile} = useBlocksLayout()
  const {yaAuthProxyHost} = useConfig()

  const contentOpened = mayBeCollapsed ? opened : true

  return (
    <Paper>
      {isTopBlock && isMobile ? (
        <Message subtitle={subtitle} title={title} />
      ) : (
        <div className={styleClasses.wrapper}>
          <div className={styleClasses.header}>
            {icon && !isMobile && (
              <img alt={icon} className={styleClasses.headerIcon} src={tag2url(icon, yaAuthProxyHost)} />
            )}
            <div className={clsx(styleClasses.fullWidth)}>
              <div
                className={clsx(styleClasses.headerTitle, {[styleClasses.mayBeCollapsed]: mayBeCollapsed})}
                onClick={mayBeCollapsed ? toggleOpened : undefined}
              >
                <Title title={title} />
                {mayBeCollapsed && (
                  <icons.ChevronRight className={opened ? styleClasses.chevronOpened : styleClasses.chevronClosed} />
                )}
              </div>

              {subtitle && <Subtitle subtitle={subtitle} />}
            </div>
          </div>

          {contentOpened && (
            <div className={styleClasses.content}>
              {text && (
                <div className={styleClasses.contentText}>
                  <Typography density="normal" level="body2" weight="regular">
                    <SafeHTML html={text} />
                  </Typography>
                </div>
              )}

              {actionInfo && (
                <>
                  <Divider />
                  <ListButton onPress={actionInfo.action} size="s" text={actionInfo.title} />
                </>
              )}
            </div>
          )}
        </div>
      )}
    </Paper>
  )
}
